export interface ShareFileOptions {
  url: string;
  fileName: string;
}

// Restrict to iOS/iPadOS — the ticket requires iOS-only share UX.
// canShare({ url: '' }) guards against browsers that expose canShare but
// return false for the data we actually share.
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isShareSupported =
  isIOS && (navigator.canShare?.({ url: "" }) ?? false);

export const shareFile = async ({
  url,
  fileName,
}: ShareFileOptions): Promise<void> => {
  try {
    const file = await prepareFile(url, fileName);
    const shareData: ShareData = {
      url,
      files: [file],
    };
    await navigator.share(shareData);
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") return;
    console.error(
      "[shareFile] Failed to share file, falling back to URL share:",
      error,
    );
    try {
      await navigator.share({ url });
    } catch (urlShareError) {
      console.error("[shareFile] Failed to share URL:", urlShareError);
      throw urlShareError;
    }
  }
};

export const prepareFile = async (fileUrl: string, fileName: string) => {
  const res = await fetch(fileUrl);
  const blob = await res.blob();
  const file = new File([blob], fileName, {
    type: blob.type,
  });
  return file;
};
